import TNTBillingBase from "../../util/TNTBillingBase";
class FuelSurchargesController extends TNTBillingBase{

    /*@ngInject*/
    constructor(Auth, $state, User, $translate, $location, $rootScope) {
        'ngInject';
        super();
        this.hasACL = {};
        this.acl = {};
        this.$rootScope = $rootScope;
        this.id = 'fuel_surcharges';
        this.$state = $state;
        this.$location = $location;
        this.$translate = $translate;
        this.Auth = Auth;
        this.User = User;

        // this.$rootScope.$broadcast('routeChange', '/app/fuel-surcharges');
    }

    $onInit() {
        super.$onInit()
        for (let key in this.acl['tnt_billing_' + this.id]) {
            this.hasACL[this.acl['tnt_billing_' + this.id][key]] = true;
        }
        this.loadPermission()
    }

    loadPermission() {
        // this.acl = {};
        // this.hasACL = {};
        [
            'fuel_surcharges',
            'price_point',
        ].forEach((permissionKey) => {
            this.acl[permissionKey] = this.User.getACL(permissionKey)

            this.hasACL[permissionKey] = {};
            if (this.acl[permissionKey] && this.acl[permissionKey].length > 0) {
                this.acl[permissionKey].forEach((permission) => {
                    this.hasACL[permissionKey][permission] = true;
                });
            }
            const currentUrl = this.$location.url();
            if (currentUrl.endsWith('/fuel-surcharges')) {
                this.$state.go('fuelSurcharges.all', ({
                    page: 1
                }));
            }
        });
    }

    goToAll() {

        this.$state.go(this.id + '.all', ({
            page: 1
        }))
    }
}
export default FuelSurchargesController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/fuel_surcharges.controller.js